'use client';

import React from 'react';
import type { DocLink } from '@/lib/news/newsUtils';
import { useOpenNewsDoc } from './NewsDocPreview';

interface NewsCitationProps {
  link: DocLink;
  /** Il testo della citazione, per l'intestazione del pannello e l'evento GTM */
  label: string;
  children: React.ReactNode;
}

/**
 * Una fonte citata nel testo: l'unica parte del Markdown che ha bisogno del
 * browser. Non è un link e non porta fuori dal sito: apre la scheda del
 * documento nel pannello laterale, come in piattaforma; l'originale si
 * raggiunge da dentro il pannello. Il Markdown intorno lo rende il server.
 */
const NewsCitation = ({ link, label, children }: NewsCitationProps) => {
  const openDoc = useOpenNewsDoc();
  const open = () => openDoc(link, label);

  return (
    <span
      role="button"
      tabIndex={0}
      className="ds-cite"
      title="Apri la scheda della fonte"
      onClick={open}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      }}
    >
      {children}
    </span>
  );
};

export default NewsCitation;
